/* The hero still on a phone: the system's own dashboard – greeting, open pipeline, the three numbers, the curve –
   rendered 1:1 in its real phone layout inside a device-like card. No browser chrome, no script; it just sits there
   and fades out at the bottom. (On wide screens the hero shows the opportunity still instead – see MbStill.) */
import React, { useEffect, useRef, useState } from "react";
import { Topbar } from "@/components/layout/Topbar";
import { OverviewBody } from "@/pages/OverviewPage";
import { Inert } from "./Stage";
import { useCountUp } from "./motion";
import { DEMO_USER, overviewData } from "./mockData";

const noop = () => {};

export const PhoneStill = ({ height = 700, testId = "tilbod-hero-phone" }) => {
  const ref = useRef(null);
  const [w, setW] = useState(0);
  const [active, setActive] = useState(false);
  const data = React.useMemo(() => overviewData(), []);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setW(Math.round(e.contentRect.width)));
    ro.observe(el);
    /* the motion starts when the card comes into view, and only then */
    const io = new IntersectionObserver((entries) => setActive(entries[entries.length - 1].isIntersecting), { threshold: 0.15 });
    io.observe(el);
    return () => {
      ro.disconnect();
      io.disconnect();
    };
  }, []);
  useCountUp(ref, active && w > 0, { delay: 600 }, [w > 0]);
  return (
    <div ref={ref} className="kvl-phone mb-frame-like" style={{ height }} data-testid={testId} data-active={active ? "1" : "0"} aria-hidden="true">
      {w > 0 && (
        <div className="mb mb-cine kvl-phone-app flex h-full w-full flex-col overflow-hidden bg-background text-foreground" style={{ width: w }} data-testid="mock-hero-dashboard">
          <Inert>
            <Topbar user={DEMO_USER} />
          </Inert>
          <Inert className="min-h-0 flex-1">
            <div className="mb-noscroll h-full overflow-hidden">
              <OverviewBody data={data} error={null} onRetry={noop} firstName="David" onOpen={noop} />
            </div>
          </Inert>
        </div>
      )}
    </div>
  );
};
